/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: nSkQWLjK-B

import * as React from "react";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import NavButton from "../../components/dashboard/NavButton"; // plasmic-import: 82ZzbE4hazN/component
import NavSection from "../../components/dashboard/NavSection"; // plasmic-import: VqaN_WL-stA/component
import OrgSwitcher from "../../components/dashboard/OrgSwitcher"; // plasmic-import: XCe0uvfI3wKX/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicDefaultLayout.module.css"; // plasmic-import: nSkQWLjK-B/css

import MarkFullColorIcon from "../plasmic_kit_design_system/PlasmicIcon__MarkFullColor"; // plasmic-import: l_n_OBLJg/icon
import ChevronDownIcon from "../plasmic_kit_design_system/icons/PlasmicIcon__ChevronDown"; // plasmic-import: C21gcG8B3Wlx/icon
import ListViewIcon from "../plasmic_kit/PlasmicIcon__ListView"; // plasmic-import: _iB8nICqsw35f/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import GolfSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__GolfSvg"; // plasmic-import: U5dSOeF1P/icon
import GearIcon from "../plasmic_kit/PlasmicIcon__Gear"; // plasmic-import: ZmVZmXEc9f_SR/icon
import ItemBulletIcon from "./icons/PlasmicIcon__ItemBullet"; // plasmic-import: MHEeMLIhlB/icon
import PlusSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PlusSvg"; // plasmic-import: sQKgd2GNr/icon
import BookSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__BookSvg"; // plasmic-import: hxRmy8Nhq/icon
import HelpIcon from "../plasmic_kit/PlasmicIcon__Help"; // plasmic-import: -9-68IGPdLG-5/icon

createPlasmicElementProxy;

export type PlasmicDefaultLayout__VariantMembers = {
  hasNoOrg: "hasNoOrg";
};
export type PlasmicDefaultLayout__VariantsArgs = {
  hasNoOrg?: SingleBooleanChoiceArg<"hasNoOrg">;
};
type VariantPropType = keyof PlasmicDefaultLayout__VariantsArgs;
export const PlasmicDefaultLayout__VariantProps = new Array<VariantPropType>(
  "hasNoOrg"
);

export type PlasmicDefaultLayout__ArgsType = {
  avatar?: React.ReactNode;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicDefaultLayout__ArgsType;
export const PlasmicDefaultLayout__ArgProps = new Array<ArgPropType>(
  "avatar",
  "children"
);

export type PlasmicDefaultLayout__OverridesType = {
  root?: Flex__<"div">;
  header?: Flex__<"header">;
  headerWrapper?: Flex__<"div">;
  headerLogoLink?: Flex__<"a">;
  headerLogo?: Flex__<"svg">;
  headerActions?: Flex__<"div">;
  userButton?: Flex__<typeof NavButton>;
  wrapper?: Flex__<"div">;
  sidebar?: Flex__<"aside">;
  nav?: Flex__<"nav">;
  allProjectsButton?: Flex__<typeof NavButton>;
  span?: Flex__<"span">;
  myProjectsButton?: Flex__<typeof NavButton>;
  orgSwitcher?: Flex__<typeof OrgSwitcher>;
  orgProjectsButton?: Flex__<typeof NavButton>;
  settingsButton?: Flex__<typeof NavButton>;
  workspaces?: Flex__<"div">;
  navButton?: Flex__<typeof NavButton>;
  newWorkspaceButton?: Flex__<typeof NavButton>;
  navFooter?: Flex__<typeof NavSection>;
  documentationButton?: Flex__<typeof NavButton>;
  helpButton?: Flex__<typeof NavButton>;
  main?: Flex__<"main">;
};

export interface DefaultDefaultLayoutProps {
  avatar?: React.ReactNode;
  children?: React.ReactNode;
  hasNoOrg?: SingleBooleanChoiceArg<"hasNoOrg">;
  className?: string;
}

const $$ = {};

function PlasmicDefaultLayout__RenderFunc(props: {
  variants: PlasmicDefaultLayout__VariantsArgs;
  args: PlasmicDefaultLayout__ArgsType;
  overrides: PlasmicDefaultLayout__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "hasNoOrg",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.hasNoOrg
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.roothasNoOrg]: hasVariant($state, "hasNoOrg", "hasNoOrg") }
      )}
    >
      <header
        data-plasmic-name={"header"}
        data-plasmic-override={overrides.header}

        className={classNames("all", sty.header)}
      >
        <div
          data-plasmic-name={"headerWrapper"}
          data-plasmic-override={overrides.headerWrapper}

          className={classNames("all", sty.headerWrapper)}
        >
          <PlasmicLink__
            data-plasmic-name={"headerLogoLink"}
            data-plasmic-override={overrides.headerLogoLink}

            className={classNames("all", "a", "a__ooL7E", sty.headerLogoLink)}
            href={"/"}
            platform={"react"}
          >
            <MarkFullColorIcon
              data-plasmic-name={"headerLogo"}
              data-plasmic-override={overrides.headerLogo}

              className={classNames("all", sty.headerLogo)}
              role={"img"}
            />
          </PlasmicLink__>
          <div
            data-plasmic-name={"headerActions"}
            data-plasmic-override={overrides.headerActions}

            className={classNames("all", sty.headerActions)}
          >
            <NavButton
              data-plasmic-name={"userButton"}
              data-plasmic-override={overrides.userButton}

              className={classNames("__wab_instance", sty.userButton)}
              endIcon={
                <ChevronDownIcon
                  className={classNames("all", sty.svg__fFzG)}
                  role={"img"}
                />
              }
              startIcon={
                <div className={classNames("all", sty.freeBox__onc7T)}>
                  {renderPlasmicSlot({
                    defaultContents: (
                      <img
                        alt={""}
                        className={classNames(
                          "all",
                          "img",
                          "img__ooL7E",
                          sty.img__lsrDh
                        )}
                        loading={"lazy"}
                      />
                    ),

                    value: args.avatar
                  })}
                </div>
              }
              withEndIcon={true}
            >
              <div className={classNames("all", "__wab_text", sty.text__owSu5)}>
                {"kim23"}
              </div>
            </NavButton>
          </div>
        </div>
      </header>
      <div
        className={classNames("all", sty.freeBox__g4Hbj, {
          [sty.freeBoxhasNoOrg__g4Hbj5Ktlm]: hasVariant(
            $state,
            "hasNoOrg",
            "hasNoOrg"
          )
        })}
      >
        <div
          data-plasmic-name={"wrapper"}
          data-plasmic-override={overrides.wrapper}

          className={classNames("all", sty.wrapper)}
        >
          <aside
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}

            className={classNames("all", sty.sidebar)}
          >
            <nav
              data-plasmic-name={"nav"}
              data-plasmic-override={overrides.nav}

              className={classNames("all", sty.nav)}
            >
              <NavSection
                className={classNames("__wab_instance", sty.navSection__xyV9M)}
                name={"Personal"}
              >
                <NavButton
                  data-plasmic-name={"allProjectsButton"}
                  data-plasmic-override={overrides.allProjectsButton}

                  className={classNames(
                    "__wab_instance",
                    sty.allProjectsButton
                  )}
                  href={"/projects"}
                  startIcon={
                    <ListViewIcon
                      className={classNames("all", sty.svg__wlFv)}
                      role={"img"}
                    />
                  }
                >
                  <span
                    data-plasmic-name={"span"}
                    data-plasmic-override={overrides.span}

                    className={classNames(
                      "all",
                      "span",
                      "span__ooL7E",
                      "__wab_text",
                      sty.span
                    )}
                  >
                    {"All projects"}
                  </span>
                </NavButton>
                <NavButton
                  data-plasmic-name={"myProjectsButton"}
                  data-plasmic-override={overrides.myProjectsButton}

                  className={classNames("__wab_instance", sty.myProjectsButton)}
                  endIcon={
                    <svg
                      className={classNames("all", sty.svg__xg0Fq)}
                      role={"img"}
                    />
                  }
                  startIcon={
                    <GolfSvgIcon
                      className={classNames("all", sty.svg__psGjc)}
                      role={"img"}
                    />
                  }
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__afr9W)}
                  >
                    {"My Playground"}
                  </div>
                </NavButton>
              </NavSection>
              <NavSection
                className={classNames("__wab_instance", sty.navSection__pxD37)}
                name={"Organization"}
              >
                <OrgSwitcher
                  data-plasmic-name={"orgSwitcher"}
                  data-plasmic-override={overrides.orgSwitcher}

                  className={classNames("__wab_instance", sty.orgSwitcher, {
                    [sty.orgSwitcherhasNoOrg]: hasVariant(
                      $state,
                      "hasNoOrg",
                      "hasNoOrg"
                    )
                  })}
                  hasNoOrg={
                    hasVariant($state, "hasNoOrg", "hasNoOrg")
                      ? true
                      : undefined
                  }
                  name={"Plasmic's First Organization"}
                  status={"trial"}
                  trialDaysLeft={12}
                />

                {(hasVariant($state, "hasNoOrg", "hasNoOrg") ? false : true) ? (
                  <div
                    className={classNames("all", sty.freeBox__qiyFd, {
                      [sty.freeBoxhasNoOrg__qiyFd5Ktlm]: hasVariant(
                        $state,
                        "hasNoOrg",
                        "hasNoOrg"
                      )
                    })}
                  >
                    {(() => {
                      try {
                        return true;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })() ? (
                      <NavButton
                        data-plasmic-name={"orgProjectsButton"}
                        data-plasmic-override={overrides.orgProjectsButton}

                        className={classNames(
                          "__wab_instance",
                          sty.orgProjectsButton
                        )}
                        startIcon={
                          <ListViewIcon
                            className={classNames("all", sty.svg__hu6Kb)}
                            role={"img"}
                          />
                        }
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___2Hr0Y
                          )}
                        >
                          {"Projects"}
                        </div>
                      </NavButton>
                    ) : null}
                    <NavButton
                      data-plasmic-name={"settingsButton"}
                      data-plasmic-override={overrides.settingsButton}

                      className={classNames(
                        "__wab_instance",
                        sty.settingsButton,
                        {
                          [sty.settingsButtonhasNoOrg]: hasVariant(
                            $state,
                            "hasNoOrg",
                            "hasNoOrg"
                          )
                        }
                      )}
                      startIcon={
                        <GearIcon
                          className={classNames("all", sty.svg__bzQjw)}
                          role={"img"}
                        />
                      }
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__rGmIi
                        )}
                      >
                        {"Settings"}
                      </div>
                    </NavButton>
                  </div>
                ) : null}
              </NavSection>
              {(hasVariant($state, "hasNoOrg", "hasNoOrg") ? false : true) ? (
                <NavSection
                  className={classNames(
                    "__wab_instance",
                    sty.navSection__fMQpr,
                    {
                      [sty.navSectionhasNoOrg__fMQpr5Ktlm]: hasVariant(
                        $state,
                        "hasNoOrg",
                        "hasNoOrg"
                      )
                    }
                  )}
                  name={"Workspaces"}
                >
                  <div
                    data-plasmic-name={"workspaces"}
                    data-plasmic-override={overrides.workspaces}

                    className={classNames("all", sty.workspaces)}
                  >
                    <NavButton
                      data-plasmic-name={"navButton"}
                      data-plasmic-override={overrides.navButton}

                      className={classNames("__wab_instance", sty.navButton)}
                      startIcon={
                        <ItemBulletIcon
                          className={classNames("all", sty.svg__zac8C)}
                          role={"img"}
                        />
                      }
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__y66Ib
                        )}
                      >
                        {"Workspace A"}
                      </div>
                    </NavButton>
                  </div>
                  <NavButton
                    data-plasmic-name={"newWorkspaceButton"}
                    data-plasmic-override={overrides.newWorkspaceButton}

                    className={classNames(
                      "__wab_instance",
                      sty.newWorkspaceButton
                    )}
                    startIcon={
                      <PlusSvgIcon
                        className={classNames("all", sty.svg__m5WS)}
                        role={"img"}
                      />
                    }
                  >
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__rXefn
                      )}
                    >
                      {"New workspace"}
                    </div>
                  </NavButton>
                </NavSection>
              ) : null}
            </nav>
            <NavSection
              data-plasmic-name={"navFooter"}
              data-plasmic-override={overrides.navFooter}

              className={classNames("__wab_instance", sty.navFooter)}
            >
              <NavButton
                data-plasmic-name={"documentationButton"}
                data-plasmic-override={overrides.documentationButton}

                className={classNames(
                  "__wab_instance",
                  sty.documentationButton
                )}
                endIcon={
                  <svg
                    className={classNames("all", sty.svg__jLkXj)}
                    role={"img"}
                  />
                }
                href={"https://docs.plasmic.app/"}
                startIcon={
                  <BookSvgIcon
                    className={classNames("all", sty.svg__o8Akv)}
                    role={"img"}
                  />
                }
                target={"_blank"}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__xywlv)}
                >
                  {"Documentation"}
                </div>
              </NavButton>
              <NavButton
                data-plasmic-name={"helpButton"}
                data-plasmic-override={overrides.helpButton}

                className={classNames("__wab_instance", sty.helpButton)}
                endIcon={
                  <svg
                    className={classNames("all", sty.svg__voKx7)}
                    role={"img"}
                  />
                }
                href={"https://forum.plasmic.app/c/5"}
                startIcon={
                  <HelpIcon
                    className={classNames("all", sty.svg__rqnIv)}
                    role={"img"}
                  />
                }
                target={"_blank"}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__cSGz7)}
                >
                  {"Help"}
                </div>
              </NavButton>
            </NavSection>
          </aside>
          <main
            data-plasmic-name={"main"}
            data-plasmic-override={overrides.main}

            className={classNames("all", sty.main, {
              [sty.mainhasNoOrg]: hasVariant($state, "hasNoOrg", "hasNoOrg")
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.children
            })}
          </main>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "headerWrapper",
    "headerLogoLink",
    "headerLogo",
    "headerActions",
    "userButton",
    "wrapper",
    "sidebar",
    "nav",
    "allProjectsButton",
    "span",
    "myProjectsButton",
    "orgSwitcher",
    "orgProjectsButton",
    "settingsButton",
    "workspaces",
    "navButton",
    "newWorkspaceButton",
    "navFooter",
    "documentationButton",
    "helpButton",
    "main"
  ],
  header: [
    "header",
    "headerWrapper",
    "headerLogoLink",
    "headerLogo",
    "headerActions",
    "userButton"
  ],
  headerWrapper: [
    "headerWrapper",
    "headerLogoLink",
    "headerLogo",
    "headerActions",
    "userButton"
  ],
  headerLogoLink: ["headerLogoLink", "headerLogo"],
  headerLogo: ["headerLogo"],
  headerActions: ["headerActions", "userButton"],
  userButton: ["userButton"],
  wrapper: [
    "wrapper",
    "sidebar",
    "nav",
    "allProjectsButton",
    "span",
    "myProjectsButton",
    "orgSwitcher",
    "orgProjectsButton",
    "settingsButton",
    "workspaces",
    "navButton",
    "newWorkspaceButton",
    "navFooter",
    "documentationButton",
    "helpButton",
    "main"
  ],
  sidebar: [
    "sidebar",
    "nav",
    "allProjectsButton",
    "span",
    "myProjectsButton",
    "orgSwitcher",
    "orgProjectsButton",
    "settingsButton",
    "workspaces",
    "navButton",
    "newWorkspaceButton",
    "navFooter",
    "documentationButton",
    "helpButton"
  ],
  nav: [
    "nav",
    "allProjectsButton",
    "span",
    "myProjectsButton",
    "orgSwitcher",
    "orgProjectsButton",
    "settingsButton",
    "workspaces",
    "navButton",
    "newWorkspaceButton"
  ],
  allProjectsButton: ["allProjectsButton", "span"],
  span: ["span"],
  myProjectsButton: ["myProjectsButton"],
  orgSwitcher: ["orgSwitcher"],
  orgProjectsButton: ["orgProjectsButton"],
  settingsButton: ["settingsButton"],
  workspaces: ["workspaces", "navButton"],
  navButton: ["navButton"],
  newWorkspaceButton: ["newWorkspaceButton"],
  navFooter: ["navFooter", "documentationButton", "helpButton"],
  documentationButton: ["documentationButton"],
  helpButton: ["helpButton"],
  main: ["main"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: "header";
  headerWrapper: "div";
  headerLogoLink: "a";
  headerLogo: "svg";
  headerActions: "div";
  userButton: typeof NavButton;
  wrapper: "div";
  sidebar: "aside";
  nav: "nav";
  allProjectsButton: typeof NavButton;
  span: "span";
  myProjectsButton: typeof NavButton;
  orgSwitcher: typeof OrgSwitcher;
  orgProjectsButton: typeof NavButton;
  settingsButton: typeof NavButton;
  workspaces: "div";
  navButton: typeof NavButton;
  newWorkspaceButton: typeof NavButton;
  navFooter: typeof NavSection;
  documentationButton: typeof NavButton;
  helpButton: typeof NavButton;
  main: "main";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDefaultLayout__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDefaultLayout__VariantsArgs;
    args?: PlasmicDefaultLayout__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicDefaultLayout__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDefaultLayout__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDefaultLayout__ArgProps,
          internalVariantPropNames: PlasmicDefaultLayout__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDefaultLayout__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDefaultLayout";
  } else {
    func.displayName = `PlasmicDefaultLayout.${nodeName}`;
  }
  return func;
}

export const PlasmicDefaultLayout = Object.assign(
  // Top-level PlasmicDefaultLayout renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    headerWrapper: makeNodeComponent("headerWrapper"),
    headerLogoLink: makeNodeComponent("headerLogoLink"),
    headerLogo: makeNodeComponent("headerLogo"),
    headerActions: makeNodeComponent("headerActions"),
    userButton: makeNodeComponent("userButton"),
    wrapper: makeNodeComponent("wrapper"),
    sidebar: makeNodeComponent("sidebar"),
    nav: makeNodeComponent("nav"),
    allProjectsButton: makeNodeComponent("allProjectsButton"),
    span: makeNodeComponent("span"),
    myProjectsButton: makeNodeComponent("myProjectsButton"),
    orgSwitcher: makeNodeComponent("orgSwitcher"),
    orgProjectsButton: makeNodeComponent("orgProjectsButton"),
    settingsButton: makeNodeComponent("settingsButton"),
    workspaces: makeNodeComponent("workspaces"),
    navButton: makeNodeComponent("navButton"),
    newWorkspaceButton: makeNodeComponent("newWorkspaceButton"),
    navFooter: makeNodeComponent("navFooter"),
    documentationButton: makeNodeComponent("documentationButton"),
    helpButton: makeNodeComponent("helpButton"),
    main: makeNodeComponent("main"),

    // Metadata about props expected for PlasmicDefaultLayout
    internalVariantProps: PlasmicDefaultLayout__VariantProps,
    internalArgProps: PlasmicDefaultLayout__ArgProps
  }
);

export default PlasmicDefaultLayout;
/* prettier-ignore-end */
